A useful report separates observation from conclusion:

  1. Run identity, revision, selection, and completeness.
  2. Folded scenario verdicts and the first failing step/error.
  3. Skip counts grouped by proven provenance.
  4. Lifecycle facts: timeout/retry/recovery and affected shard attempts.
  5. Relevant artifacts and scenario history.
  6. Focused rerun result, if performed.
  7. Classification: application bug, test issue, harness issue, or inconclusive.
  8. Confidence and the next discriminating check.

Share summary.md and manifest.json from the workspace. Do not paste credentials,
raw environment variables, or private artifact URLs into tickets. The diagnostic
API already omits control-plane secrets, but customer test logs may still contain
application data and should follow the customer's normal handling policy.
